/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanDlmBaseResponse } from '../models/boolean-dlm-base-response';
import { ProductMarkupConfigDto } from '../models/product-markup-config-dto';
import { ProductMarkupConfigDtoDlmBaseResponse } from '../models/product-markup-config-dto-dlm-base-response';
import { ProductMarkupProductTypeConfigDto } from '../models/product-markup-product-type-config-dto';
import { ProductMarkupProductTypeConfigDtoDlmBaseResponse } from '../models/product-markup-product-type-config-dto-dlm-base-response';
import { ProductMarkupProductTypeConfigDtoListDlmBaseResponse } from '../models/product-markup-product-type-config-dto-list-dlm-base-response';

@Injectable({
  providedIn: 'root',
})
export class ProductMarkupConfigService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiProductMarkupConfigGet
   */
  static readonly ApiProductMarkupConfigGetPath = '/api/ProductMarkupConfig';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductMarkupConfigGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductMarkupConfigGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<ProductMarkupConfigDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductMarkupConfigService.ApiProductMarkupConfigGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductMarkupConfigDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductMarkupConfigGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductMarkupConfigGet$Plain(params?: {
  }): Observable<ProductMarkupConfigDtoDlmBaseResponse> {

    return this.apiProductMarkupConfigGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ProductMarkupConfigDtoDlmBaseResponse>) => r.body as ProductMarkupConfigDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductMarkupConfigGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductMarkupConfigGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<ProductMarkupConfigDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductMarkupConfigService.ApiProductMarkupConfigGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductMarkupConfigDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductMarkupConfigGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductMarkupConfigGet$Json(params?: {
  }): Observable<ProductMarkupConfigDtoDlmBaseResponse> {

    return this.apiProductMarkupConfigGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProductMarkupConfigDtoDlmBaseResponse>) => r.body as ProductMarkupConfigDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiProductMarkupConfigPut
   */
  static readonly ApiProductMarkupConfigPutPath = '/api/ProductMarkupConfig';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductMarkupConfigPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductMarkupConfigPut$Plain$Response(params?: {
    body?: ProductMarkupConfigDto
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductMarkupConfigService.ApiProductMarkupConfigPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductMarkupConfigPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductMarkupConfigPut$Plain(params?: {
    body?: ProductMarkupConfigDto
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiProductMarkupConfigPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductMarkupConfigPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductMarkupConfigPut$Json$Response(params?: {
    body?: ProductMarkupConfigDto
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductMarkupConfigService.ApiProductMarkupConfigPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductMarkupConfigPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductMarkupConfigPut$Json(params?: {
    body?: ProductMarkupConfigDto
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiProductMarkupConfigPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiProductMarkupConfigProductTypeConfigsGet
   */
  static readonly ApiProductMarkupConfigProductTypeConfigsGetPath = '/api/ProductMarkupConfig/product-type-configs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductMarkupConfigProductTypeConfigsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductMarkupConfigProductTypeConfigsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<ProductMarkupProductTypeConfigDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductMarkupConfigService.ApiProductMarkupConfigProductTypeConfigsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductMarkupProductTypeConfigDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductMarkupConfigProductTypeConfigsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductMarkupConfigProductTypeConfigsGet$Plain(params?: {
  }): Observable<ProductMarkupProductTypeConfigDtoListDlmBaseResponse> {

    return this.apiProductMarkupConfigProductTypeConfigsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ProductMarkupProductTypeConfigDtoListDlmBaseResponse>) => r.body as ProductMarkupProductTypeConfigDtoListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductMarkupConfigProductTypeConfigsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductMarkupConfigProductTypeConfigsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<ProductMarkupProductTypeConfigDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductMarkupConfigService.ApiProductMarkupConfigProductTypeConfigsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductMarkupProductTypeConfigDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductMarkupConfigProductTypeConfigsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductMarkupConfigProductTypeConfigsGet$Json(params?: {
  }): Observable<ProductMarkupProductTypeConfigDtoListDlmBaseResponse> {

    return this.apiProductMarkupConfigProductTypeConfigsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProductMarkupProductTypeConfigDtoListDlmBaseResponse>) => r.body as ProductMarkupProductTypeConfigDtoListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiProductMarkupConfigProductTypeConfigPut
   */
  static readonly ApiProductMarkupConfigProductTypeConfigPutPath = '/api/ProductMarkupConfig/product-type-config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductMarkupConfigProductTypeConfigPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductMarkupConfigProductTypeConfigPut$Plain$Response(params?: {
    body?: ProductMarkupProductTypeConfigDto
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductMarkupConfigService.ApiProductMarkupConfigProductTypeConfigPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductMarkupConfigProductTypeConfigPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductMarkupConfigProductTypeConfigPut$Plain(params?: {
    body?: ProductMarkupProductTypeConfigDto
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiProductMarkupConfigProductTypeConfigPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductMarkupConfigProductTypeConfigPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductMarkupConfigProductTypeConfigPut$Json$Response(params?: {
    body?: ProductMarkupProductTypeConfigDto
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductMarkupConfigService.ApiProductMarkupConfigProductTypeConfigPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductMarkupConfigProductTypeConfigPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductMarkupConfigProductTypeConfigPut$Json(params?: {
    body?: ProductMarkupProductTypeConfigDto
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiProductMarkupConfigProductTypeConfigPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiProductMarkupConfigProductTypeConfigPost
   */
  static readonly ApiProductMarkupConfigProductTypeConfigPostPath = '/api/ProductMarkupConfig/product-type-config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductMarkupConfigProductTypeConfigPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductMarkupConfigProductTypeConfigPost$Plain$Response(params?: {
    body?: ProductMarkupProductTypeConfigDto
  }): Observable<StrictHttpResponse<ProductMarkupProductTypeConfigDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductMarkupConfigService.ApiProductMarkupConfigProductTypeConfigPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductMarkupProductTypeConfigDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductMarkupConfigProductTypeConfigPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductMarkupConfigProductTypeConfigPost$Plain(params?: {
    body?: ProductMarkupProductTypeConfigDto
  }): Observable<ProductMarkupProductTypeConfigDtoDlmBaseResponse> {

    return this.apiProductMarkupConfigProductTypeConfigPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ProductMarkupProductTypeConfigDtoDlmBaseResponse>) => r.body as ProductMarkupProductTypeConfigDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductMarkupConfigProductTypeConfigPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductMarkupConfigProductTypeConfigPost$Json$Response(params?: {
    body?: ProductMarkupProductTypeConfigDto
  }): Observable<StrictHttpResponse<ProductMarkupProductTypeConfigDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductMarkupConfigService.ApiProductMarkupConfigProductTypeConfigPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductMarkupProductTypeConfigDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductMarkupConfigProductTypeConfigPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProductMarkupConfigProductTypeConfigPost$Json(params?: {
    body?: ProductMarkupProductTypeConfigDto
  }): Observable<ProductMarkupProductTypeConfigDtoDlmBaseResponse> {

    return this.apiProductMarkupConfigProductTypeConfigPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ProductMarkupProductTypeConfigDtoDlmBaseResponse>) => r.body as ProductMarkupProductTypeConfigDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiProductMarkupConfigProductTypeConfigDelete
   */
  static readonly ApiProductMarkupConfigProductTypeConfigDeletePath = '/api/ProductMarkupConfig/product-type-config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductMarkupConfigProductTypeConfigDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductMarkupConfigProductTypeConfigDelete$Plain$Response(params?: {
    productTypeMarkupId?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductMarkupConfigService.ApiProductMarkupConfigProductTypeConfigDeletePath, 'delete');
    if (params) {
      rb.query('productTypeMarkupId', params.productTypeMarkupId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductMarkupConfigProductTypeConfigDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductMarkupConfigProductTypeConfigDelete$Plain(params?: {
    productTypeMarkupId?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiProductMarkupConfigProductTypeConfigDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductMarkupConfigProductTypeConfigDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductMarkupConfigProductTypeConfigDelete$Json$Response(params?: {
    productTypeMarkupId?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductMarkupConfigService.ApiProductMarkupConfigProductTypeConfigDeletePath, 'delete');
    if (params) {
      rb.query('productTypeMarkupId', params.productTypeMarkupId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiProductMarkupConfigProductTypeConfigDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductMarkupConfigProductTypeConfigDelete$Json(params?: {
    productTypeMarkupId?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiProductMarkupConfigProductTypeConfigDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

}
